import React from 'react';
import { Outlet } from 'react-router-dom';
import AuthRoute from '../AuthRoute';
import FileManagement from '@/page/wechat/fileManagement';
import ReportStatistics from '@/page/wechat/reportStatistics';
import BUMember from '@/page/wechat/buMember';
import ITMember from '@/page/wechat/itMember';
import RouteRedirect from '@/app/wrapper/RouteRedirect';
import Log from '@/page/wechat/log';
import TaTagManagement from '@/page/wechat/taTagManagement';
import { UserOutlined, FileOutlined, BarChartOutlined, FileTextOutlined, TagsOutlined } from '@/icons';
const wechatMenu = {
    title: '',
    path: 'wechat',
    element: <Outlet />,
    children: [
        {
            index: true,
            element: <RouteRedirect menuKey="wechatMenu" />,
        },
        {
            label: '文件管理',
            path: 'fileManagement',
            icon: <FileTextOutlined />,
            authorities: ['global:share_app_file_mgr:r'],
            element: (
                <AuthRoute onAuthorities={['global:share_app_file_mgr:r']}>
                    <FileManagement />
                </AuthRoute>
            ),
        },
        {
            label: 'BU成员设置',
            path: 'buMember',
            icon: <UserOutlined />,
            authorities: ['global:share_app_bu_member_mgr:r'],
            element: (
                <AuthRoute onAuthorities={['global:share_app_bu_member_mgr:r']}>
                    <BUMember />
                </AuthRoute>
            ),
        },
        {
            label: 'IT成员管理',
            path: 'itMember',
            icon: <UserOutlined />,
            authorities: ['global:share_app_it_member_mgr:r'],
            element: (
                <AuthRoute onAuthorities={['global:share_app_it_member_mgr:r']}>
                    <ITMember />
                </AuthRoute>
            ),
        },
        {
            label: '报表统计',
            path: 'reportStatistics',
            icon: <BarChartOutlined />,
            authorities: ['global:share_app_report_mgr:r'],
            element: (
                <AuthRoute onAuthorities={['global:share_app_report_mgr:r']}>
                    <ReportStatistics />
                </AuthRoute>
            ),
        },
        {
            label: 'Admin日志',
            path: 'log',
            icon: <FileOutlined />,
            authorities: ['global:share_app_admin_log:r'],
            element: (
                <AuthRoute onAuthorities={['global:share_app_admin_log:r']}>
                    <Log />
                </AuthRoute>
            ),
        },
        {
            label: 'TA Tag管理',
            path: 'taTagManagement',
            icon: <TagsOutlined />,
            authorities: ['global:share_app_taTag_log:r'],
            element: (
                <AuthRoute onAuthorities={['global:share_app_taTag_log:r']}>
                    <TaTagManagement />
                </AuthRoute>
            ),
        },
    ],
};
export default wechatMenu;
